import { FC, Fragment, useContext, useState } from 'react';
import { MoContext } from 'contexts/MoContext';
import { actionTargetsOrder, useOrdersAction } from '../Assistant/ordersActions';
import { OrderRow } from 'ts/shared/interfaces/MOResponse';
import Button from 'components/ui/Button/Button';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { copyOrderJson } from 'services/myOrders';
import { showError, showSuccess } from 'utils/utils';

interface MoCopyOrderJsonProps {
  orderRow: OrderRow;
}

const MoCopyOrderJson: FC<MoCopyOrderJsonProps> = ({ orderRow }) => {
  const [t] = useTranslation();
  const { activeOrder } = useContext(MoContext);
  const [loading, setLoading] = useState(false);
  const isActive = activeOrder?.orderRow.segmentId === orderRow.segmentId;

  const onCopy = async () => {
    setLoading(true);
    const res = await copyOrderJson({
      orderId: orderRow.orderId,
      segmentId: orderRow.segmentId,
    });

    if (res) {
      await navigator.clipboard.writeText(res);
      showSuccess(t('mo.clipboard_success'));
    } else {
      showError(t('something_went_wrong'));
    }

    setLoading(false);
  };

  useOrdersAction(
    (action) =>
      action.action === 'copy-json' &&
      actionTargetsOrder(action, { segmentId: orderRow.segmentId, orderId: orderRow.orderId }, isActive),
    () => {
      void onCopy();
    },
    isActive,
  );

  return (
    <Fragment>
      <Button
        onClick={onCopy}
        title={t(loading ? 'mo.loading' : 'Copy Order JSON')}
        className="btn btn-default btn-ssm"
        disabled={loading}
        icon={faCopy}
        iconclassname="mr-5"
      />
    </Fragment>
  );
};

export default MoCopyOrderJson;
